'use client';

import { ReactNode, useEffect, useState } from 'react';

import { registerServiceWorker } from '~/libs/pushNotifications';

type ServiceWorkerProviderProps = {
  children: ReactNode;
};

export const ServiceWorkerProvider = ({
  children,
}: ServiceWorkerProviderProps) => {
  const [_isRegistered, setIsRegistered] = useState(false);

  useEffect(() => {
    // Register service worker on client side
    const registerSW = async () => {
      try {
        const registration = await registerServiceWorker();
        if (registration) {
          console.log('Service Worker registered successfully in provider');
          setIsRegistered(true);
        }
      } catch (error) {
        console.error('Failed to register Service Worker:', error);
      }
    };

    // Only register in browser environment
    if (typeof window !== 'undefined') {
      registerSW();
    }
  }, []);

  return <>{children}</>;
};
